export default "__VITE_ASSET__BYuny_x$__"